.bar {
  position: fixed;
  top: 50%;
  left: var(--sidebar-width);
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  z-index: 100;
  padding: 6px 4px;
  background: var(--bg-surface);
  border-right: 1px solid var(--border);
  border-radius: 12px;
  margin-left: 10px;
}

.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 10px;
  cursor: pointer;
  transition: all var(--transition-fast);
  color: var(--text-muted);
  font-size: 18px;
}

.toggle:hover {
  color: var(--accent-cyan);
  border-color: var(--accent-cyan);
  background: rgba(0, 240, 255, 0.08);
  box-shadow: 0 0 12px var(--glow-cyan);
}

.toggleActive {
  color: var(--accent-cyan);
  border-color: var(--accent-cyan);
  background: rgba(0, 240, 255, 0.12);
  box-shadow: 0 0 16px var(--glow-cyan);
}

.icon {
  line-height: 1;
  pointer-events: none;
}

.menu {
  display: none;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  padding: 10px;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 0 24px var(--glow-cyan);
  white-space: nowrap;
  min-width: 160px;
  /* 限制弹框最大宽度，防止超长 slug URL（menuDesc）把弹框撑得过宽 */
  max-width: 340px;
}

.menuOpen {
  display: flex;
}

.menuTitle {
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  color: var(--accent-cyan);
  letter-spacing: 2px;
  text-transform: uppercase;
  padding-bottom: 6px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--border);
  width: 100%;
}

.menuItem {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 8px;
  border-radius: 6px;
  text-decoration: none;
  transition: background var(--transition-fast);
  width: 100%;
}

.menuItem:hover {
  background: rgba(0, 240, 255, 0.08);
}

.menuLink {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  color: var(--accent-green);
}

.menuDesc {
  font-size: 11px;
  color: var(--text-muted);
  /* 覆盖菜单整体的 nowrap：超长 URL（如 /article/超长标题.md）按字符换行，不撑宽弹框 */
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
}
